/*=========================================================================================
  File Name: moduleActivity.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleTutorialState.js'
import mutations from './moduleTutorialMutations.js'
import actions from './moduleTutorialActions.js'
import getters from './moduleTutorialGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters
}

